export const AUTHENTICATE_REQUEST = `@@ddw.herdnet.sandbox.hnadvice/AUTHENTICATE_REQUEST`;
export const AUTHENTICATE_SUCCESS = `@@ddw.herdnet.sandbox.hnadvice/AUTHENTICATE_SUCCESS`;
export const AUTHENTICATE_FAILURE = `@@ddw.herdnet.sandbox.hnadvice/AUTHENTICATE_FAILURE`;

export const LOGOUT = `@@ddw.herdnet.sandbox.hnadvice/LOGOUT`;
